import { fromLonLat } from 'ol/proj';

import DrawingUtils from '../utils/DrawingUtils';

/**
 * Dock(도크 기지) 마커 관리 Feature
 */
class DockFeature {
  constructor(createOverlay, map) {
    this.createOverlay = createOverlay;
    this.map = map;
    this.docks = {};
  }

  /**
   * Dock 마커 추가 또는 업데이트
   * @param {string} robotId - 로봇 ID
   * @param {Object} position - { lat, lng } 좌표
   * @param {string} color - 마커 색상
   */
  addMarker(robotId, position, color) {
    // 기존 Dock Marker
    if (this.docks[robotId]) {
      this.docks[robotId].position = position;
      this.docks[robotId].marker.setPosition(fromLonLat([position.lng, position.lat]));
    }
    // 신규 Dock Marker
    else {
      this.docks[robotId] = {
        position,
        marker: DrawingUtils.drawMarker(this.createOverlay, this.map, position, 'D', color),
      };
    }
  }

  /**
   * Dock 마커 제거
   * @param {string} robotId - 로봇 ID
   */
  removeMarker(robotId) {
    if (!this.docks[robotId]) return;

    this.map.removeOverlay(this.docks[robotId].marker);
    delete this.docks[robotId];
  }

  /**
   * Dock 데이터 가져오기
   * @param {string} robotId - 로봇 ID
   * @returns {Object|undefined} Dock 데이터
   */
  get(robotId) {
    return this.docks[robotId];
  }
}

export default DockFeature;
